"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPlay', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15 8C15 8.34562 14.8215 8.66674 14.528 8.84923L4.77802 14.9114C4.46966 15.1031 4.0816 15.1126 3.76421 14.9363C3.44683 14.7599 3.25 14.4253 3.25 14.0622L3.25 1.93782C3.25 1.57471 3.44683 1.24014 3.76421 1.06374C4.0816 0.88735 4.46966 0.89686 4.77802 1.08859L14.528 7.15077C14.8215 7.33326 15 7.65438 15 8ZM5.25 3.73712L5.25 12.2629L12.1061 8L5.25 3.73712Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M20 10C20 10.3573 19.8094 10.6874 19.5 10.866L6 18.6603C5.6906 18.8389 5.3094 18.8389 5 18.6603C4.6906 18.4816 4.5 18.1515 4.5 17.7942L4.5 2.20577C4.5 1.84851 4.6906 1.51838 5 1.33975C5.3094 1.16111 5.6906 1.16111 6 1.33975L19.5 9.13398C19.8094 9.31261 20 9.64274 20 10ZM6.5 3.93782L6.5 16.0622L17 10L6.5 3.93782Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M24 12C24 12.3573 23.8094 12.6874 23.5 12.866L7 22.3923C6.6906 22.5709 6.3094 22.5709 6 22.3923C5.6906 22.2137 5.5 21.8835 5.5 21.5263L5.5 2.47372C5.5 2.11645 5.6906 1.78633 6 1.60769C6.3094 1.42906 6.6906 1.42906 7 1.60769L23.5 11.134C23.8094 11.3126 24 11.6427 24 12ZM7.5 4.20577L7.5 19.7942L21 12L7.5 4.20577Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M32 16C32 16.3573 31.8094 16.6874 31.5 16.866L9 29.8564C8.6906 30.035 8.3094 30.035 8 29.8564C7.6906 29.6778 7.5 29.3476 7.5 28.9904L7.5 3.00962C7.5 2.65235 7.6906 2.32223 8 2.14359C8.3094 1.96496 8.6906 1.96496 9 2.14359L31.5 15.134C31.8094 15.3126 32 15.6427 32 16ZM9.5 4.74167L9.5 27.2583L29 16L9.5 4.74167Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;